export default __webpack_public_path__ + "static/media/cyber_threat_intelligence.9a5694b6.png";